import React, { CSSProperties } from 'react';
import { ModalManager } from '../../models/ModalManager';

interface IProps {
  header?: string;
  message?: string;
}

const handleBtnClick = () => {
  ModalManager.closeModal();
};

const AlertModal: React.FC<IProps> = (props) => {
  return (
    <div style={containerStyle}>
      {props.header && <h3 style={headerStyle}>{props.header}</h3>}
      {props.message && <p style={paragraphStyle}>{props.message}</p>}

      <button className={'nes-btn'} style={buttonsStyle} onClick={handleBtnClick}>
        OK
      </button>
    </div>
  );
};

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};

const headerStyle: CSSProperties = {
  textAlign: 'center',
};

const paragraphStyle: CSSProperties = {
  textAlign: 'center',
};

const buttonsStyle: CSSProperties = {
  margin: '20px',
};

export default AlertModal;
